import { useState, useRef, useEffect } from 'react';

export function VideoEmbed({ videoId, title, className }) {
    const [isPlaying, setIsPlaying] = useState(false);
    const [bgLoaded, setBgLoaded] = useState(false);
    const thumbnailUrl = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
    const iframeUrl = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`;
    const divRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setBgLoaded(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.1 }
        );

        if (divRef.current) observer.observe(divRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <>
            {isPlaying ? (
                <iframe
                    src={iframeUrl}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                    title={title}
                    className={className}
                />
            ) : (
                <div
                    ref={divRef}
                    onClick={() => setIsPlaying(true)}
                    style={{
                        backgroundImage: bgLoaded ? `url(${thumbnailUrl})` : 'none',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    className={className}
                >
                    {/* Botão play */}
                    <div
                        style={{
                            width: '80px',
                            height: '80px',
                            backgroundColor: 'rgba(0,0,0,0.6)',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <div
                            style={{
                                width: 0,
                                height: 0,
                                borderLeft: '25px solid white',
                                borderTop: '15px solid transparent',
                                borderBottom: '15px solid transparent',
                                marginLeft: '5px',
                            }}
                        />
                    </div>
                </div>
            )}
        </>
    );
}
